var _circle, _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGoogle(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 24,
    cy: 24,
    r: 24,
    fill: "#F7F7F7"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M38.9999 24.3597C38.9999 23.3063 38.9075 22.3063 38.7492 21.333H23.8364V27.3463H32.375C31.9922 29.3197 30.8705 30.9863 29.2076 32.1197V36.1197H34.3017C37.2843 33.333 38.9999 29.2263 38.9999 24.3597Z",
    fill: "#4285F4"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M23.8367 40.0004C28.1126 40.0004 31.689 38.5604 34.302 36.1204L29.208 32.1204C27.7827 33.0804 25.9747 33.667 23.8367 33.667C19.706 33.667 16.2088 30.8537 14.9551 27.0537H9.70264V31.1737C12.3025 36.4004 17.6473 40.0004 23.8367 40.0004Z",
    fill: "#34A853"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M14.9549 27.0538C14.6249 26.0938 14.4534 25.0671 14.4534 24.0005C14.4534 22.9338 14.6381 21.9071 14.9549 20.9471V16.8271H9.70243C8.62026 18.9871 8 21.4138 8 24.0005C8 26.5871 8.62026 29.0138 9.70243 31.1738L14.9549 27.0538Z",
    fill: "#FBBC05"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M23.8367 14.3333C26.1726 14.3333 28.2578 15.1467 29.9074 16.7333L34.4208 12.1733C31.689 9.58667 28.1126 8 23.8367 8C17.6473 8 12.3025 11.6 9.70264 16.8267L14.9551 20.9467C16.2088 17.1467 19.706 14.3333 23.8367 14.3333Z",
    fill: "#EA4335"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGoogle);
export default __webpack_public_path__ + "static/media/google.d647f7424866bac74404ce393556362d.svg";
export { ForwardRef as ReactComponent };